import { WeblabedFeatures } from 'src/commons/constants';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';

export default (featureName: WeblabedFeatures): boolean => {
  const { config } = useInternalChromeConfigContext();
  if (!config.featureLaunchInfo) {
    return false;
  }

  const feature = config.featureLaunchInfo.features.find(
    (feature) => feature.name === featureName,
  );

  return feature ? feature.isEnabled : false;
};
